import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventOnboardingDecision } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
type NewOnboardingDecisionEvent = {
  event: UserTimelineEventOnboardingDecision['data'];
};
const NewWorkflowStartedEvent = t0 => {
  const $ = _c(10);
  const {
    event
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.events.onboardingDecision"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  if (event.decision.workflowKind === "adhoc_vendor_call") {
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <span className="text-primary text-label-2">{t2}</span>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t) {
      t4 = t(_temp2);
      $[5] = t;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== t3 || $[8] !== t4) {
      t5 = <div className="flex gap-1 text-body-2 text-tertiary">{t3}{t4}</div>;
      $[7] = t3;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  return null;
};
export default NewWorkflowStartedEvent;
function _temp($) {
  return $.adhocVendorCall.adhoc;
}
function _temp2($_0) {
  return $_0.adhocVendorCall.finished;
}